import React from 'react';
import { cn } from './cn';

export type CardPad = 'none' | 'sm' | 'md' | 'lg';

const pads: Record<CardPad, string> = {
  none: '',
  sm: 'p-4',
  md: 'p-5 md:p-6',
  lg: 'p-6 md:p-8',
};

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  pad?: CardPad;
}

/**
 * Superficie básica: blanco sobre fondo papel, filete cálido y sombra mínima.
 * El "ledger" se lee en los filetes (hairlines), no en sombras pesadas.
 */
export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ pad = 'md', className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn('rounded-lg border border-hairline bg-white shadow-card', pads[pad], className)}
      {...rest}
    />
  ),
);
Card.displayName = 'Card';

export default Card;
